const indicationRoutes = [
  {
    path: "/indication",
    component: () =>
      import(/* webpackChunkName: "patient" */ "../layouts/PatientLayout.vue"),
  },
];

export default indicationRoutes;
